module.exports = __webpack_public_path__ + "static/media/switch-on.ccbccc58.svg";